import { useMoldMaintenanceMonitor } from "@/hooks/useMoldMaintenanceMonitor";
import { useAuth } from "@/contexts/AuthContext";
import { canViewMaintenanceAlerts } from "@/lib/roleUtils";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { AlertTriangle, Wrench } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export function MoldMaintenanceAlerts() {
  const { userRole } = useAuth();
  
  // Solo mostrar a roles autorizados
  if (!canViewMaintenanceAlerts(userRole)) {
    return null;
  }

  const { moldsNeedingMaintenance } = useMoldMaintenanceMonitor();
  const navigate = useNavigate();

  if (!moldsNeedingMaintenance || moldsNeedingMaintenance.length === 0) {
    return null;
  }

  return (
    <Card className="border-amber-500/20 bg-amber-500/5">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-amber-600 dark:text-amber-400">
          <AlertTriangle className="w-5 h-5" />
          Alertas de Mantenimiento de Moldes
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        {moldsNeedingMaintenance.map((mold) => (
          <div
            key={mold.id}
            className="flex items-center justify-between p-3 rounded-lg bg-background border"
          >
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-1">
                <span className="font-medium">{mold.name}</span>
                {mold.code && (
                  <span className="text-sm text-muted-foreground">
                    ({mold.code})
                  </span>
                )}
                <Badge
                  variant={mold.severity === "critical" ? "destructive" : "outline"}
                  className={
                    mold.severity === "warning"
                      ? "bg-amber-500/10 text-amber-600 border-amber-500/20"
                      : ""
                  }
                >
                  {mold.severity === "critical" ? "Crítico" : "Advertencia"}
                </Badge>
              </div>
              <div className="text-sm text-muted-foreground">
                <span className="font-medium">
                  {mold.current_uses} / {mold.max_uses}
                </span>{" "}
                usos ({mold.usagePercentage.toFixed(1)}%)
              </div>
            </div>
            <Button
              variant="outline"
              size="sm"
              onClick={() => navigate("/molds")}
            >
              <Wrench className="w-4 h-4 mr-2" />
              Ver Moldes
            </Button>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
